import { CommonModule } from '@angular/common';
import {} from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PrimeNGModule } from './primeng.module';
import { PictureCropperComponent } from './components/picture-cropper/picture-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CommentComponent } from './components/comment/comment.component';
import { ConversationsComponent } from './components/conversations/conversations.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { GoalsGeneratorComponent } from '../smart-goals-generator/goals-generator/goals-generator.component';
import { GoalsCardComponent } from '../relation/components/goals-card/goals-card.component';
import { GoogleLoginButtonComponent } from './components/google-login-button/google-login-button.component';
import { SafeHTMLPipe } from '../shared/pipes/safe-html.pipe';
import { GoalsTrackerComponent } from '../relation/components/goals-tracker/goals-tracker.component';
import { MatchedPopupComponent } from './components/matched-popup/matched-popup.component';
import { RecordingComponent } from './components/recording/recording.component';
import { RoleTogglerComponent } from './components/role-toggler/role-toggler.component';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { TranslateModule } from '@ngx-translate/core';
import { VocativeNamePipe } from './pipes/vocative-name.pipe';
import { LocalizedValuePipe } from '../shared/pipes/localized-value.pipe';
import { CalendarLocaleDirective } from './directives/calendar-locale.directive';
import { AutoCompleteLocaleDirective } from './directives/autocomplete-locale.directive';
import { MaintenanceComponent } from '../service-pages/maintenance/maintenance.component';
import { FarewellComponent } from '../service-pages/farewell/farewell.component';
import { LinkedinLoginButtonComponent } from './components/linkedin-login-button/linkedin-login-button.component';
import { LinkedinCallbackComponent } from './components/linkedin-callback/linkedin-callback.component';
import { MatchModalComponent } from './components/new_matching-alert/new-matching-alert.component';

const SHARED_MODULES = [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, PrimeNGModule];

@NgModule({
  declarations: [
    CommentComponent,
    ConversationsComponent,
    PictureCropperComponent,
    FileUploadComponent,
    GoalsGeneratorComponent,
    GoalsCardComponent,
    GoalsTrackerComponent,
    SafeHTMLPipe,
    MatchedPopupComponent,
    RecordingComponent,
    RoleTogglerComponent,
    LanguageSwitcherComponent,
    VocativeNamePipe,
    LocalizedValuePipe,
    CalendarLocaleDirective,
    AutoCompleteLocaleDirective,
    MaintenanceComponent,
    FarewellComponent,
    GoogleLoginButtonComponent,
    LinkedinLoginButtonComponent,
    LinkedinCallbackComponent,
  ],
  imports: [...SHARED_MODULES, ImageCropperModule, TranslateModule, MatchModalComponent],
  exports: [
    ...SHARED_MODULES,
    CommentComponent,
    ConversationsComponent,
    PictureCropperComponent,
    FileUploadComponent,
    GoalsGeneratorComponent,
    GoalsCardComponent,
    GoalsTrackerComponent,
    SafeHTMLPipe,
    MatchedPopupComponent,
    RecordingComponent,
    RoleTogglerComponent,
    LanguageSwitcherComponent,
    TranslateModule,
    VocativeNamePipe,
    LocalizedValuePipe,
    CalendarLocaleDirective,
    AutoCompleteLocaleDirective,
    MaintenanceComponent,
    FarewellComponent,
    GoogleLoginButtonComponent,
    LinkedinLoginButtonComponent,
    MatchModalComponent,
  ],
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
